export enum ReportPanelType {
  SINGLE_DEVICE = 'singleDevice',
  SINGLE_USER = 'singleUser',
  MODEL_AUE_BY_OU = 'modelAueByOu',
  FIFTEEN_DAY_ACTIVITY_BY_OU = 'fifteenDayActivityByOu',
  CHROME_VERSION_AGE_BY_OU = 'chromeVersionAgeByOu',
  BATTERY_HEALTH_BY_OU = 'batteryHealthByOu',
  STORAGE_BY_OU = 'storageByOu',
}

/**
 * Report type constants matching ReportType from report-viewer.model.ts
 * Use these in templates to avoid hardcoded strings
 */
export const REPORT_TYPES = {
  SINGLE_DEVICE_USAGE: 'single-device-usage',
  SINGLE_USER: 'SINGLE_USER',
  MODEL_AUE: 'model-aue',
  FIFTEEN_DAY_ACTIVITY: 'fifteen-day-activity',
  CHROME_VERSION_AGE: 'chrome-version-age',
  BATTERY_HEALTH: 'battery-health',
  STORAGE_BY_OU: 'storage-by-ou',
} as const;

export enum DeviceSearchByOption {
  SERIAL_NUMBER = 'serialNumber',
  DEVICE_ID = 'deviceId',
  ASSET_ID = 'assetId',
  ANNOTATED_USER = 'annotatedUser',
}

export enum UserSearchByOption {
  EMAIL = 'email',
  NAME = 'name',
}
